<footer class="w-full bg-white border-t border-slate-100 py-3" role="contentinfo">
    <div
        class="max-w-[1200px] mx-auto px-6 w-full flex flex-col md:flex-row items-center justify-between gap-4 relative">
        <div class="flex items-center">
            <div class="flex items-center gap-1">
                <span
                    class="text-[12px] font-black text-[#003359] tracking-tight uppercase leading-none">Student Support Services</span>
                <span class="text-[12px] font-medium text-slate-600  uppercase leading-none">Portal</span>
            </div>
        </div>

        <div class="md:absolute md:left-1/2 md:-translate-x-1/2">
            <span class="text-[11px] text-slate-600 font-medium whitespace-nowrap">
                © {{ currentYear }} Encoura. All rights reserved.
            </span>
        </div>

        <nav class="flex items-center gap-6 text-[11px] font-bold text-slate-700" aria-label="Footer Navigation">
            <a href="https://www.encoura.org/privacy-policy/" target="_blank" rel="noopener noreferrer"
                class="text-[11px] font-bold text-slate-600 hover:text-primary transition-colors duration-200">Privacy</a>
            <a href="https://www.encoura.org/terms-of-use/" target="_blank" rel="noopener noreferrer"
                class="text-[11px] font-bold text-slate-600 hover:text-primary transition-colors duration-200">Terms
                of Use</a>
        </nav>
    </div>
</footer>